import Vue from 'vue';
import { MutationTree } from 'vuex';
import { ContentProgress, ContinueStudying, UndergradProgressState } from './state';

interface SetProgress {
  id: string;
  progress: number;
  content: ContentProgress;
}

const getConcatIds = (content: ContentProgress) =>
  content.subModuleId + content.disciplineId + content.disciplineVersionId;

const mutations: MutationTree<UndergradProgressState> = {
  SET_PROGRESS_LOADING: (state, loading: boolean) => {
    state.loading = loading;
  },
  SET_PROGRESS_OUTDATED: (state, outdated: boolean) => {
    state.outdated = outdated;
  },
  SET_LESSONS_TO_CONTINUE_STUDYING: (state, continueStudying: ContinueStudying[]) => {
    state.continueStudying = continueStudying;
  },
  SET_COURSE_PROGRESS: (state, { id, progress }: SetProgress) => {
    Vue.set(state.courses, id, progress);
  },
  SET_MODULE_PROGRESS: (state, { id, progress }: SetProgress) => {
    Vue.set(state.modules, id, progress);
  },
  SET_DISCIPLINE_PROGRESS: (state, { content, progress }: SetProgress) => {
    Vue.set(state.disciplines, getConcatIds(content), progress);
  },
  SET_LESSON_PROGRESS: (state, { content, progress }: SetProgress) => {
    Vue.set(state.lessons, getConcatIds(content) + content.lessonId, progress);
  },
  SET_CONTENT_PROGRESS: (state, { id, content, progress }: SetProgress) => {
    Vue.set(state.contents, getConcatIds(content) + content.lessonId + id, progress);
    if (content.consumptionMoment) {
      Vue.set(
        state.moments,
        getConcatIds(content) + content.lessonId + id,
        new Date(content.consumptionMoment),
      );
    }
  },
};

export default mutations;
